import React from "react"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import styled, {css} from "styled-components"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import authentication from "@irati/auth"
import {Body, H2, H4, H6} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import FormattedMessage from "@irati/utils/lang"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {CelebrationTag} from "@irati/types"
interface Props extends WithBranding {
  generic?: boolean
  boxed?: boolean
  rewardTemplate?: CelebrationTag
  rewardTitle?: string
  rewardMessage: string
  rewardPoints: number
}
const Container = styled(Flex)`
  ${({theme, boxed}) => css`
    ${boxed &&
    css`
      border: 1px solid ${theme.colors.greys.grey20};
    `}

    margin-top: ${theme.spacing.three};
  `}
`
const PreviewImage = styled.img`
  ${({boxed}) => css`
    max-width: 50%;
    max-height: ${boxed ? "130px" : "unset"};
  `}
`
const LogoPreview = styled.img`
  max-height: 30px;
`
const MAX_MESSAGE_BOXED = 120
const PreviewContent = (props: Props) => {
  const {branding, boxed, generic, rewardMessage, rewardTitle, rewardPoints, rewardTemplate} = props
  const theme = useTheme()
  const user = authentication.user().firstName
  const previewTitle = !generic && `${rewardTitle || rewardTemplate?.label}, ${user}`
  const truncatedMessage = rewardMessage?.substring(0, boxed ? MAX_MESSAGE_BOXED : rewardMessage.length)
  const message = truncatedMessage && boxed && rewardMessage?.length > MAX_MESSAGE_BOXED ? `${truncatedMessage}...` : truncatedMessage
  const PointsTitleComponent = boxed ? H6 : H4
  const TitleHeadingComponent = boxed ? H4 : H2
  return (
    <Container gap={1} padding={2} direction="column" alignItems="center" boxed={boxed}>
      <LogoPreview src={branding.businessLogoUrl} alt="Brand logo" />
      <TitleHeadingComponent marginBottom={boxed ? 0 : theme.spacing.half}>
        {previewTitle || <FormattedMessage id="wallet.reward.template.title" />}
      </TitleHeadingComponent>
      <Flex gap={1} marginBottom={theme.spacing.oneAndHalf}>
        <Icon icon={IconTypes.rewardPoints} />
        <PointsTitleComponent>
          <FormattedMessage id="platform.wallet.reward.template.pointsPerUser" values={{points: rewardPoints}} />
        </PointsTitleComponent>
      </Flex>
      <PreviewImage
        boxed={boxed}
        src={boxed ? rewardTemplate?.cover?.href : rewardTemplate?.image?.href}
        alt={rewardTemplate?.cover?.alt}
      />
      <Body small marginTop={boxed ? theme.spacing.one : theme.spacing.two} textAlign="center" wordBreak="break-word">
        {message || <FormattedMessage id="platform.wallet.reward.admin.distribute.messageBox.label" />}
      </Body>
    </Container>
  )
}

export default withBranding(PreviewContent)
